import { createProvider } from '@nvision/services/data-provider';

import * as api from './api';

export const deleteClaims = createProvider(api.deleteClaims).andCatch((error) => {
  if (error instanceof Error && error.name === 'AbortError') {
    console.warn('Delete claims aborted');
  } else {
    console.error('Delete claims was failed:', error);
  }
  throw error;
});
